var _this = this;
import * as tslib_1 from "tslib";
import 'sentry';
import { enableProdMode } from '@angular/core';
import { environment } from 'environments/environment';
import { version } from '../package.json';
import * as __NgCli_bootstrap_1 from "./app/app.module.ngfactory";
import * as __NgCli_bootstrap_2 from "@angular/platform-browser";
console.warn('version', version);
if (environment.production) {
    enableProdMode();
}
__NgCli_bootstrap_2.platformBrowser()
    .bootstrapModuleFactory(__NgCli_bootstrap_1.AppModuleNgFactory)
    .then(function (module) { return tslib_1.__awaiter(_this, void 0, void 0, function () {
    return tslib_1.__generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                if (!(navigator.serviceWorker && environment.SERVICE_WORKER)) return [3 /*break*/, 2];
                return [4 /*yield*/, navigator.serviceWorker
                        .register('./ngsw-worker.js', { scope: location.pathname })
                        .catch(function (err) { return console.error('Service worker registration failed', err); })];
            case 1:
                _a.sent();
                _a.label = 2;
            case 2: return [2 /*return*/, module];
        }
    });
}); })
    .catch(function (err) { return console.error(err); });
